import { useCssVars as _useCssVars, unref as _unref } from 'vue';
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "sk-fading-circle"
};
import { MAIN_COLOR } from '@/common/constants/ConstCode';
import { computed } from 'vue';
export default {
  __name: 'AppgCircularSpinner',
  setup(__props) {
    _useCssVars(_ctx => ({
      "5d000002": mainColor.value
    }));
    const mainColor = computed(() => MAIN_COLOR);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [_createStaticVNode("<div class=\"sk-circle1 sk-circle\" data-v-f2cf36aa></div><div class=\"sk-circle2 sk-circle\" data-v-f2cf36aa></div><div class=\"sk-circle3 sk-circle\" data-v-f2cf36aa></div><div class=\"sk-circle4 sk-circle\" data-v-f2cf36aa></div><div class=\"sk-circle5 sk-circle\" data-v-f2cf36aa></div><div class=\"sk-circle6 sk-circle\" data-v-f2cf36aa></div><div class=\"sk-circle7 sk-circle\" data-v-f2cf36aa></div><div class=\"sk-circle8 sk-circle\" data-v-f2cf36aa></div><div class=\"sk-circle9 sk-circle\" data-v-f2cf36aa></div><div class=\"sk-circle10 sk-circle\" data-v-f2cf36aa></div><div class=\"sk-circle11 sk-circle\" data-v-f2cf36aa></div><div class=\"sk-circle12 sk-circle\" data-v-f2cf36aa></div>", 12)]));
    };
  }
};